<template>
  <ValidationProvider
    tag="div"
    :rules="rules"
    :label="label"
    :vid="vid"
    v-slot="{ errors }"
    class="mob-drop-down-currency "
  >
    <div class="flow-align">
      <label>{{ label }}</label>
      <!-- {{options}}
        {{assignedCurrency}} -->

      <!-- deselect-label="Can't remove this value" placeholder="Select one" -->
      <multiselect
        v-model="selValueModel"
        :track-by="ctrlCode"
        placeholder="Select"
        :options="options"
        :searchable="isSearchable"
        :multiple="isMultiple"
        :allow-empty="isAllowEmpty"
        :taggable="isTaggable"
        :loading="isShowLoading ? isInValidOptions() : false"
        :custom-label="customLabel"
        @input="emitVal"
        deselectLabel=""
        deselectGroupLabel=""
        selectLabel=""
        selectedLabel=""
      >
   
        <!-- <template slot="singleLabel" slot-scope="{ props }"> {{ props.option.currency_code.code }}</template> -->

        <!-- <template slot="option" slot-scope="props">
                <div><span>{{ props.option[ctrlName] }}</span>
                    <strong class="right" v-if="isShowCode">{{ props.option[ctrlCode] }}</strong>
                </div>
            </template> -->
            <template #noResult>
                <strong >
                  {{resultEmpty}}
                </strong>
              </template>
              <template #noOptions>
                <strong >
                  {{optionEmpty}}
                </strong>
              </template>
      </multiselect>

      <div class="invalid-feedback ">
        <div v-show="!selValueModel || selValueModel.length == 0">
          <span>{{ errors[0] }}</span>
        </div>
      </div>
    </div>

    <div v-show="noAgents">{{$t("cAlert.noData")}}</div>
    <div v-show="showAlert">
<CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";

import apiGetCurrencyLs from "../../services/apiGetCurrencyLs.js";
// import apiGetOrgCurrencyLs from "../../services/apiGetOrgCurrencyLs.js";
import { mapGetters, mapActions } from "vuex";
import { PAGE_NAME ,ORDER} from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import {
  handleJWT,
  getErrorAlertValue,
  differenceBy,
  cloneData,OrderByList
} from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME, CITIZEN } from "../../util/constants";
export default {
  name: COMPONENT_NAME.C_AGENT_CURRENCY,
  components: {
    ValidationProvider,
    Multiselect
  },
  model: {
    prop: "selValue"
  },

  props: {
    selValue: {
      type: Object | Array
    },
    isShowCode: {
      type: Boolean,
      default: false
    },

    isMultiple: {
      type: Boolean,
      default: false
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    ctrlName: {
      type: Array,
      default: null
    },
    ctrlCode: {
      type: String,
      default: ""
    },
    // url: {
    //   type: String,
    //   default: null
    // },
    rules: {
      type: [String, Object],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    vid: {
      type: String,
      default: undefined
    },
    value: {
      type: Object,
      default: null
    },
    isAllowEmpty: {
      type: Boolean,
      default: true
    },
    defaultCurrency: {
      type: Object | Array,
      default: null
    },
    assignedCurrency: {
      type: Object | Array,
      default: null
    },
    isShowDefaultCurrency: {
      type: Boolean,
      default: true
    },
    isTaggable: {
      type: Boolean,
      default: false
    },
    isShowLoading: {
      type: Boolean,
      default: true
    },
    resultEmpty: {
      type: String,
      // default: 'No matching items found'
      default: function () {
    return  this.$t("cAlert.resEmpty") }
    },
    optionEmpty: {
      type: String,
      default: function () {
    return this.$t("cAlert.optEmpty") }
    },
  },
  data: () => ({
    options: [],
    selected: false,
    selValueModel: {
      name: null,
      code: null,
      symbol: null,
      amount: null
    },
    showAlert: false,
    noAgents: false,
    alertValue: null
  }),

  watch: {
    //this.selValueModel = this.selValue;
    selValue(val) {
      if (val !== this.selValueModel) {
        this.selValueModel = val;
      }
    }
  },

  async created() {
    try {
      this.selValueModel = this.selValue;
    // let orgCurrencyRes = JSON.parse(JSON.stringify( this.orgCurrencyRes))
      this.options = await this.getCurrencyDpOptions(
        this.currencyRes,
        this.selValueModel,
        this.isMultiple,
        this.GET_AGENT_CURRENCIES
      );

      if (this.options) {
        // if (this.assignedCurrency) {
        //   let selOptionToRemove = [];
        //   let optList = cloneData(this.options);
        //   for (let opIndex = 0; opIndex < optList.length; opIndex++) {
        //     const opt = optList[opIndex];
        //     for (let index = 0; index < this.assignedCurrency.length; index++) {
        //       const curr = this.assignedCurrency[index];
        //       if (opt.currency_code.code == curr.code) {
        //        // delete this.options[opIndex];
        //       // this.options.splice(opIndex,1);
        //       //  opIndex--;
        //       selOptionToRemove.push(opt);             
        //       }
        //     }           
        //   }
        //   let newOPtions = differenceBy(this.options,selOptionToRemove,"currency_code");
        //   if(newOPtions)
        //   this.options = newOPtions;
        // }
        // if (this.selValue && this.isMultiple && this.selValue.length) {
        //   let selectedLabel = [];

        //   for (let selectedValue of this.selValueModel) {
        //     if (
        //       selectedValue &&
        //       selectedValue.currecycode &&
        //       selectedValue.currecycode.code
        //     ) {
        //       selectedLabel.push(
        //         this.options.find(curr => {
        //           return (
        //             curr.currecycode.code == selectedValue.currecycode.code
        //           );
        //         })
        //       );
        //     }
        //   }

        //   this.selValueModel = selectedLabel;
        // }

        this.SET_AGENT_CURRENCIES(this.options);
      this.options=OrderByList(this.options,this.getPropToSortCurrList,ORDER.ASC);

      }
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.APPROVE_AGENT,
        "error in Created",
        err.toString(),
        "Created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
    ...mapGetters("sCurrencyLs", {
      currencyRes: "GET_CURRENCY_RES",

    }),
    ...mapGetters("sCurrencyLs", {
      GET_AGENT_CURRENCIES: "GET_AGENT_CURRENCIES",

    }),
     ...mapGetters("sDashBoard", {
      GET_AGENT_FINANCE_RES: "GET_AGENT_FINANCE_RES",

    })
    
    
  
  },

  methods: {
    ...mapActions("sCurrencyLs", ["SET_CURRENCY_RES"]),
    ...mapActions("sCurrencyLs", ["SET_AGENT_CURRENCIES"]),

    customLabel(option) {
      return `${option.currecycode.code} `;
    },

    emitVal(value) {
      this.$emit("input", value);
    },

    // isActive(poptions) {
    //   let option = [];
    //   try {
    //     if (poptions) {
    //       for (let j = 0; j < poptions.length; j++) {
    //         if (poptions[j].isactive) {
    //           option.push(poptions[j]);
    //         }
    //       }
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_AGENT_CURRENCY,
    //       "error in isActive",
    //       err.toString(),
    //       "isActive",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return option;
    // },
     getPropToSortCurrList(pCurr) {
         try {
           if(BaseConfiguration.isDebug) console.log("getPropToSortCurrList");
          if(pCurr.currecycode.code){
            return pCurr.currecycode.code.toLowerCase();
          }
     
         } catch (err) {
                 let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGENT_CURRENCY,
                   "error in getPropToSortCurrList",
                   err.toString(),
                   "getPropToSortCurrList",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           
         }, 
    async getCurrencyDpOptions(
      pcurrencyRes,
      pselValueModel,
      pisMultiple,
      pAgentCurrencyRes
      

    ) {
      let retValue;
      try {
        if (!pcurrencyRes ) {
          retValue = await this.getCurrencyListRes();

        //   retValue = this.isActive(retValue);
          if (!pselValueModel) {
            pselValueModel = this.getDefaultCurrencyCode(retValue);
            if (pisMultiple) {
              if (pselValueModel) this.emitVal([pselValueModel]);
              else this.emitVal(pselValueModel);
            } else {
              this.emitVal(pselValueModel);
            }
          }
        } else {
          if (!pAgentCurrencyRes||pAgentCurrencyRes.length==0) {
            // retValue = await this.getOrgCurrencyListRes(pcurrencyRes);
        retValue = this.getCurrFromBalanceRes(this.GET_AGENT_FINANCE_RES);
            // retValue = this.isActive(retValue);
            if (!pselValueModel) {
              pselValueModel = this.getDefaultCurrencyCode(retValue);
              if (pisMultiple) {
                if (pselValueModel) this.emitVal([pselValueModel]);
                else this.emitVal(pselValueModel);
              } else {
                this.emitVal(pselValueModel);
              }
            }
          } else {
            retValue = pAgentCurrencyRes;
            // retValue = this.isActive(retValue);
            if (!pselValueModel) {
              pselValueModel = this.getDefaultCurrencyCode(retValue);
              if (pisMultiple) {
                if (pselValueModel) this.emitVal([pselValueModel]);
                else this.emitVal(pselValueModel);
              } else {
                this.emitVal(pselValueModel);
              }
            }
          }
          if (BaseConfiguration.isDebug) console.log("options from store!");
        }

      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_AGENT_CURRENCY,
          "error in getCurrencyDpOptions",
          err.toString(),
          "getCurrencyDpOptions",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getDefaultCurrencyCode(pOptionsList) {
      let retValue;
      try {
        let currList = [];
        if (pOptionsList   && pOptionsList.length > 0) {
          for (let i = 0; i < pOptionsList.length; i++) {
              retValue=pOptionsList[0];
            // if (!this.isShowDefaultCurrency) {
            //   retValue = null;
            // } else if (this.defaultCurrency) {
            //   if (pOptionsList[i].currecycode.code == this.defaultCurrency) {
            //     retValue = pOptionsList[i];
            //     break;
            //   }
            // } else {
            //   if (
            //     pOptionsList[i].currecycode.code ==
            //     BaseConfiguration.defaultCurrencyObj.code
            //   ) {
            //     retValue = pOptionsList[i];
            //     break;
            //   }
            // }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_AGENT_CURRENCY,
          "error in dropdown options",
          err.toString(),
          "getDefaultCurrencyCode",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },

    // getDefaultCurrencyCode(pOptionsList) {
    //   let retValue;
    //   try {
    //     let currList = [];
    //     if (pOptionsList != null && pOptionsList.length > 0) {
    //       for (let i = 0; i < pOptionsList.length; i++) {
    //         if (!this.isShowDefaultCurrency) {
    //           retValue = null;
    //         } else if (this.defaultCurrency) {
    //           if (pOptionsList[i].currecycode.code == this.defaultCurrency) {
    //             retValue = pOptionsList[i];
    //             break;
    //           }
    //         } else {
    //           if (
    //             pOptionsList[i].currecycode.code ==
    //             BaseConfiguration.defaultCurrencyObj.code
    //           ) {
    //             retValue = pOptionsList[i];
    //             break;
    //           }
    //         }
    //       }
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.cCurrencyDropDown,
    //       "error in dropdown options",
    //       err.toString(),
    //       "getDefaultCurrencyCode",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }

    //   return retValue;
    // },

    isInValidOptions() {
      try {
        if (BaseConfiguration.isDebug) console.log(" isInValidOptions");

        let retValue = false;
        if (this.options && this.options.length > 0)
          //check options length
          retValue = false;
        else retValue = true;
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_AGENT_CURRENCY,
          "error while checking invalid options",
          err.toString(),
          "isInValidOptions",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    
    getCurrFromBalanceRes(pBalanceRes) {
   let retValue=pBalanceRes;

        try {
          if(BaseConfiguration.isDebug) console.log("getCurrFromBalanceRes");
            if (this.currencyRes) {
            for (let j = 0; j < retValue.length; j++) {
              for (let i = 0; i < this.currencyRes.length; i++) {
                if (this.currencyRes[i].code == (retValue[j].currecycode.constructor==Object?retValue[j].currecycode.code:retValue[j].currecycode)) {
                  retValue[j].currecycode = this.currencyRes[i];

                  break;
                }
              }
            }
          }
          this.SET_AGENT_CURRENCIES(retValue);
    
        } catch (err) {
                let body = Logger.buildRequest(
                   COMPONENT_NAME.C_AGENT_CURRENCY,
                  "error in getCurrFromBalanceRes",
                  err.toString(),
                  "getCurrFromBalanceRes",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    //api call to get currency list
    async getCurrencyListRes() {
      // this.countrySel=true;
      let retValue;
      try {
        let currencyLsResponse = await apiGetCurrencyLs.getResponse();
        if (
          VALIDATE_SUCCESS_RES(currencyLsResponse) &&
          currencyLsResponse.data.data.length > 0
        ) {
          this.SET_CURRENCY_RES(currencyLsResponse.data.data); //save res in store
          // retValue = currencyLsResponse.data.data;
        //   retValue = await this.getOrgCurrencyListRes();
         retValue = this.getCurrFromBalanceRes(this.GET_AGENT_FINANCE_RES);

        } else {
          this.showAlert = true;

          let error = getErrorMessage(currencyLsResponse);

          let isJwt = handleJWT(error);
          if (!isJwt) {
            this.alertValue = getErrorAlertValue(error);
          }
        }

        //  } else {
        //     throw "invalid country request";
        //   }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.API_GET_CURRENCY_LIST,
          "error in getting response from GetCurrencyLs API",
          err.toString(),
          "GetCurrencyLsRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },

   
  }
};
</script>
